import React, {  useState } from "react";
import { connect } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import initialState from "core/reducers/initialState";
import { Classes, Dialog } from "@blueprintjs/core";
import TokenSession from "core/util/session/TokenSession";

const IdleStateHandler = props => {
	let timeout = props.timeOut;
	// if timeout not set -> setting as 24hrs
	timeout = timeout ? timeout * 60000 : 24 *60 * 60000;

	const [isIdle, setIdle] = useState<boolean>(false);
	let promptBeforeIdle = null;

	const onIdle = () => {
		setIdle(true);
		//waiting for 10 sec before the logout
		promptBeforeIdle = setTimeout(initLogout, 10000);
	};

	const initLogout = () => {
		clearWaitingTimeOut();
		TokenSession.logout();
	};

	const clearWaitingTimeOut = () => {
		if (promptBeforeIdle) {
			clearTimeout(promptBeforeIdle);
		}
	};

	const onActive = () => {};
	// Registrating timer
	useIdleTimer({
		onIdle,
		onActive,
		timeout
	});

	return (
		<div style={{ display: "block" }}>
			<Dialog icon="info-sign" isOpen={isIdle}>
				<div className={Classes.DIALOG_BODY}>
					<h3>
						You have been logged out of the system. Please login
						again..
					</h3>
				</div>
			</Dialog>
		</div>
	);
};

function mapStateToProps(state: typeof initialState = initialState) {
	return {
		timeOut: state.config.contextProperties["ui.session.timeout"]
	};
}

export default connect(mapStateToProps)(IdleStateHandler);



// WEBPACK FOOTER //
// ./src/core/components/IdleStateHandler.tsx